import { addMessages } from '@hana/i18n';

// Khoá chuỗi bảng phải của Ezy › Dịch vụ. Dữ liệu thông báo mẫu không dịch.
addMessages('vi', {
  'svd.panel': 'Bảng bên phải', 'svd.tasks': 'Việc theo dịch vụ', 'svd.noti': 'Thông báo', 'svd.close': 'Đóng bảng',
  'nrp.def': '{nat} · {v} (mặc định)', 'nrp.feeCode': '{code} · mã phí', 'nrp.pendingTip': 'Mã phí chờ cấp', 'nrp.pending': 'chờ cấp',
});
addMessages('en', {
  'svd.panel': 'Right panel', 'svd.tasks': 'Tasks by service', 'svd.noti': 'Notifications', 'svd.close': 'Close panel',
  'nrp.def': '{nat} · {v} (default)', 'nrp.feeCode': '{code} · fee code', 'nrp.pendingTip': 'Fee code pending', 'nrp.pending': 'pending',
});
